import { Injectable } from '@angular/core';
import * as forge from 'node-forge';

@Injectable()
export class EncryptService {

  constructor() { }

  encryptWithPublicKey(data: string, publicKeyString: string): string {
    const publicKeyPem = this.convertBase64ToPem(publicKeyString);
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
    const encrypted = publicKey.encrypt(data);

    return forge.util.encode64(encrypted);
  }

  private convertBase64ToPem(base64Key: string): string {
    const keyBody = base64Key.match(/.{1,64}/g);
    if (keyBody) {
      return `-----BEGIN PUBLIC KEY-----\n${keyBody.join('\n')}\n-----END PUBLIC KEY-----`;
    } else {
      throw new Error('Invalid Base64 key format');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/encrypt/encrypt.service.ts